import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const MATERIAL_PHOTOS = {
  cement: { src: "/catalogue/materials/cement-pallets.jpg", name: "Cement", blurb: "Ordinary Portland, high strength, masonry, bulk & bagged" },
  lumber: { src: "/catalogue/materials/lumber-truck.jpg", name: "Lumber", blurb: "Framing, plywood, treated, roofing & decking" },
  steel: { src: "/catalogue/materials/steel-yard-hero.webp", name: "Steel", blurb: "Rebar, beams, tubing, angle, pipe & mesh" },
};
export const GATED = Object.keys(MATERIAL_PHOTOS);

export function ExportBanner() {
  return (
    <Link to="/export" className="group relative block rounded-2xl overflow-hidden h-56 sm:h-64 lg:h-72 shadow-lg" data-testid="export-global-banner" aria-label="We export globally — open the SHOP NOW Export hub">
      <picture>
        <source srcSet="/catalogue/materials/export-global-banner.webp" type="image/webp" />
        <img src="/catalogue/materials/export-global-banner.jpg" alt="International container port with cargo ship, freight aircraft and trucks" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" loading="lazy" width="1376" height="768" />
      </picture>
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/35 to-black/10" />
      <div className="absolute left-5 sm:left-8 bottom-5 sm:bottom-8 right-5">
        <span className="inline-block h-1 w-16 bg-[#b32a2a] mb-3" />
        <div className="font-clash font-bold uppercase leading-[0.9] text-white text-4xl sm:text-5xl lg:text-6xl">We export<br /><span className="bg-gradient-to-r from-[#f5d67a] via-[#d4af37] to-[#b8902a] bg-clip-text text-transparent">globally</span></div>
        <div className="mt-3 text-xs sm:text-sm text-white/85 max-w-xl">Steel, lumber, cement and Jamaica-made goods shipped to the Caribbean, USA, Canada, UK & EU — quotation first, documents handled by our export desk.</div>
        <div className="mt-3 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-[#f5d67a]">Open the Export hub <ArrowUpRight size={14} /></div>
      </div>
    </Link>
  );
}

export function SupplyBanner({ compact = false }) {
  return (
    <Link to="/pallet-loader" className="block rounded-2xl overflow-hidden border border-black/10 hover:opacity-95 transition-opacity" data-testid="supply-banner" aria-label="Endless Supply. Endless Possibilities — open the Pallet Loader">
      <img src="/catalogue/materials/possibilities-banner.jpg" alt="SHOP NOW — Endless Supply. Endless Possibilities. Steel, lumber and cement delivered Jamaica-wide" className={`w-full ${compact ? "max-h-56 object-cover object-left" : ""}`} loading="lazy" />
    </Link>
  );
}

export function MaterialGate({ selected, onPick, to, counts = {} }) {
  const items = GATED.map((k, i) => ({ key: k, idx: i, ...MATERIAL_PHOTOS[k] }));
  return (
    <section className="space-y-3" data-testid="material-gate">
      <div><h2 className="font-clash font-bold text-2xl sm:text-3xl uppercase">Pick your material first</h2><p className="text-sm text-muted-foreground">Choose cement, lumber or steel before you build your order.</p></div>
      <div className="grid sm:grid-cols-3 gap-4">
        {items.map((m) => {
          const inner = (
            <>
              <img src={m.src} alt={m.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10" />
              <span className="absolute top-3 left-3 bg-black/60 text-white/90 font-mono text-xs px-2 py-1 rounded">0{m.idx + 1} / 0{items.length}</span>
              <span className="absolute top-3 right-3 bg-white text-ink rounded p-1.5"><ArrowUpRight size={16} /></span>
              <div className="absolute left-4 right-4 bottom-4 text-white">
                <div className="font-clash font-bold text-3xl sm:text-4xl uppercase leading-none">{m.name}</div>
                <div className="text-sm text-white/85 mt-1">{m.blurb}</div>
                <div className="mt-3 flex items-center gap-3 text-xs font-bold uppercase tracking-wider"><span className="h-1 w-16 bg-[#b32a2a]" />{counts[m.key] != null ? `${counts[m.key]} products` : "Select"}</div>
              </div>
            </>
          );
          const cls = `group relative block h-72 sm:h-80 rounded-2xl overflow-hidden text-left ${selected === m.key ? "ring-4 ring-[#b32a2a]" : ""}`;
          return onPick
            ? <button key={m.key} onClick={() => onPick(m.key)} className={cls} data-testid={`gate-${m.key}`}>{inner}</button>
            : <Link key={m.key} to={to ? to(m.key) : `/materials/${m.key}`} className={cls} data-testid={`gate-${m.key}`}>{inner}</Link>;
        })}
      </div>
    </section>
  );
}
